import { z } from 'zod';

import { schemaEuropaceProcessEvent } from './ProcessEvent.schema';
import {
    schemaEuropaceProcessOfferEvent,
    schemaEuropaceProcessOfferEventWithoutToken,
} from './ProcessOfferEvent.schema';

export const schemaEuropaceProcessEvents = z.object({
    offers: z.array(schemaEuropaceProcessOfferEvent),
    process: z.array(schemaEuropaceProcessEvent),
});

export type SchemaEuropaceProcessEvents = z.infer<typeof schemaEuropaceProcessEvents>;

export const schemaEuropaceProcessEventsWithoutToken = schemaEuropaceProcessEvents.extend({
    offers: z.array(schemaEuropaceProcessOfferEventWithoutToken),
});

export type SchemaEuropaceProcessEventsWithoutToken = z.infer<typeof schemaEuropaceProcessEventsWithoutToken>;
